import { ParticlesEntity } from "./ParticlesEntity";
import { ParticlesSettings } from "./ParticlesSettings";
import { EmitterSettings } from "./EmitterSettings";
import { Pool } from "../../../../Utils/Collections/Pool";
import { NodeList } from "../../../../Utils/Collections/NodeList";
import { Node } from "../../../../Utils/Collections/Node";
import { rnd } from "../../../../Game";



export class ParticlesEmitter {
    private _freeEntities: Pool<ParticlesEntity>;
    private _actEntities: NodeList<ParticlesEntity>;

    private _emitSettings: EmitterSettings;
    private _partSettings: ParticlesSettings;

    private _nextPartTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(root: pc.GraphNode) {
        // Seznamy entit
        this._freeEntities = new Pool<ParticlesEntity>(undefined, 4, true, (): ParticlesEntity => {
            return new ParticlesEntity(root);
        });
        this._actEntities = new NodeList<ParticlesEntity>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(emitterSettings: EmitterSettings, particlesSettings: ParticlesSettings): void {
        this._emitSettings = emitterSettings;
        this._partSettings = particlesSettings;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._actEntities.forEach((e: ParticlesEntity) => {
            e.reset();
            this._freeEntities.returnItem(e);
        });
        this._actEntities.clear();

        this._nextPartTime = this._emitSettings.emitTimer.time + this._emitSettings.emitMinInterval;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(viewPos: pc.Vec3): void {
        let timer = this._emitSettings.emitTimer;

        // Zpracovat aktivni entity
        this._actEntities.forEach((e: ParticlesEntity, node: Node<ParticlesEntity>) => {
            if (!e.update(timer.deltaS, viewPos.z + this._emitSettings.endOffsetZ)) {
                e.reset();
                this._actEntities.removeByNode(node);
                this._freeEntities.returnItem(e);
            }
        });

        // Vytvoreni novych castic
        if (this._nextPartTime <= timer.time) {
            let e = this._freeEntities.getItem();

            e.init(this._partSettings, viewPos, this._emitSettings.emitOffset);
            this._actEntities.add(e);

            this._nextPartTime = timer.time + rnd.randomIntIn(this._emitSettings.emitMinInterval, this._emitSettings.emitMaxInterval);
        }
    }
}